export default __webpack_public_path__ + "static/media/people-high-five.21308453.png";